module.exports = __webpack_public_path__ + "deb48d08b1f0b57f349c0642e7d6fdfa.pdf";